import { adminCustomersFeatureFlagsPostSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminCustomersFeatureFlagsReducers = combineReducers({
	post: adminCustomersFeatureFlagsPostSlice.asyncReducers
});

export const adminCustomersFeatureFlagsWatchers = combineAllWatchers([
	adminCustomersFeatureFlagsPostSlice.asyncWatchers
]);
